import { render, staticRenderFns } from "./bulletin.vue?vue&type=template&id=0e1a0a7c&scoped=true"
import script from "./bulletin.vue?vue&type=script&lang=js"
export * from "./bulletin.vue?vue&type=script&lang=js"
import style0 from "./bulletin.vue?vue&type=style&index=0&id=0e1a0a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a0a7c",
  null
  
)

export default component.exports